import { IonContent, IonLoading, IonPage, useIonViewWillEnter } from '@ionic/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorNetwork } from '../../components/error/ErrorNetwork';
import { useRemoveWomenPeriodMutation, useWomenPeriodsQuery } from '../../generated/graphql';
import { Title } from '../../components/title/Title';
import { AddButton } from '../../components/UI/AddButton/AddButton';
import { WomenCalendarList } from '../../components/women-calendar-list/WomenCalendarList';

const WomenCalendarListPage = () => {
  const { t } = useTranslation();

  const { data, loading, error, refetch } = useWomenPeriodsQuery({
    fetchPolicy: 'no-cache',
  });

  useIonViewWillEnter(() => {
    if (data) refetch();
  }, [data]);

  const [removeWomenPeriod, { loading: removeWomenPeriodLoading }] = useRemoveWomenPeriodMutation({
    onCompleted: () => {
      refetch();
    },
  });

  const handleRemoveWomenPeriod = async (id: string) => {
    await removeWomenPeriod({
      variables: {
        input: { id },
      },
    });
  };

  if (loading) {
    return <IonLoading isOpen message={t('Loading...')} />;
  }

  return (
    <IonPage>
      <Title
        translucent
        title="Women's calendar"
        menuButton
        sort={{
          sortButton: true,
          callback: () => {},
        }}
      />
      <IonContent>
        {error ? (
          <ErrorNetwork error={error} />
        ) : (
          data && (
            <>
              <WomenCalendarList removeWomenPeriod={handleRemoveWomenPeriod} data={data} />
              <AddButton routeLink="women-calendar/new" />
            </>
          )
        )}
      </IonContent>
      {!loading && removeWomenPeriodLoading && <IonLoading isOpen message={t('Loading...')} />}
    </IonPage>
  );
};

export { WomenCalendarListPage };
